import { i18n } from 'next-i18next';
import HotelRoom from '../../types/RoomAvailability';

type Meal = NonNullable<HotelRoom['mealPlans']>[0]['meal'];

const getMealPlanCategoryText = (meal: Meal | undefined) => {
  if (!meal) {
    return i18n?.t('common:without_meal');
  }
  const { breakfast, lunch, dinner } = meal;
  const text = [];

  if (breakfast) {
    text.push(i18n?.t('common:breakfast'));
  }
  if (lunch) {
    text.push(i18n?.t('common:lunch'));
  }
  if (dinner) {
    text.push(i18n?.t('common:dinner'));
  }

  return text.length
    ? i18n?.t('common:with', { meal: text.join(' + ') })
    : i18n?.t('common:without_meal');
};

export default getMealPlanCategoryText;
